import React from 'react';
import '../App.css';
import { useTranslation } from 'react-i18next';

function RiskAndReturn() {
  const { t } = useTranslation(); // 預設使用 'translation' namespace

  return (
    <div className="article-container">
      <h2>{t('riskAndReturn.title')}</h2>
      <p>{t('riskAndReturn.paragraph1')}</p>

      <h3>{t('riskAndReturn.riskAversionHeading')}</h3>
      <p>{t('riskAndReturn.paragraph2')}</p>

      <h3>{t('riskAndReturn.psychologyInRiskHeading')}</h3>
      <p>{t('riskAndReturn.paragraph3')}</p>

      <h3>{t('riskAndReturn.riskAversionAndRoleHeading')}</h3>
      <p>{t('riskAndReturn.paragraph4')}</p>
    </div>
  );
}

export default RiskAndReturn;
